<script>
import Checkbox from '../common/form/checkbox/Checkbox.vue';
import NumberInput from '../common/form/input/NumberInput.vue';
import TextInput from '../common/form/input/TextInput.vue';

export default {
    components: {
        'kgr-checkbox': Checkbox,
    },
    props: {
        name: {
            type: String,
            required: true,
        },
        element: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            settings: {},
            mixinsSettings: {},
        };
    },
    created() {
        if (this.element.hasOwnProperty('mixins')) {
            this.element.mixins.forEach((mixinElement) => this.extractSettingsForProps(mixinElement.props, this.mixinsSettings));
        }

        this.extractSettingsForProps(this.element.props, this.settings);
    },
    methods: {
        extractSettingsForProps(props, settings) {
            for (const prop in props) {
                if (props[prop].type === String) {
                    let value = props[prop].example;
                    if (value === undefined || value === null) {
                        value = props[prop].default;
                    }
                    if (value === undefined || value === null) {
                        value = 'Lorem Ipsum';
                    }
                    settings[prop] = value;
                }
                if (props[prop].type === Number) {
                    let value = props[prop].example;
                    if (value === undefined || value === null) {
                        value = props[prop].default;
                    }
                    if (value === undefined || value === null) {
                        value = 10;
                    }
                    settings[prop] = value;
                }
                if (props[prop].type === Boolean) {
                    let value = props[prop].example;
                    if (value === undefined || value === null) {
                        value = props[prop].default;
                    }
                    if (value === undefined || value === null) {
                        value = true;
                    }
                    settings[prop] = value;
                }
            }
        },
        renderSettings(settings, props, createElement) {
            const renderedProps = [];

            for (const prop in settings) {
                if (props[prop].type === String) {
                    renderedProps.push(createElement(TextInput, {
                        props: {
                            label: prop,
                            value: settings[prop],
                        },
                        style: {
                            marginBottom: '0.5rem',
                        },
                        on: {
                            input: (event) => {
                                settings[prop] = event;
                                this.$forceUpdate();
                            },
                        },
                    }));
                }
                if (props[prop].type === Number) {
                    renderedProps.push(createElement(NumberInput, {
                        props: {
                            label: prop,
                            value: settings[prop],
                        },
                        style: {
                            marginBottom: '0.5rem',
                        },
                        on: {
                            input: (event) => {
                                settings[prop] = event;
                                this.$forceUpdate();
                            },
                        },
                    }));
                }
                if (props[prop].type === Boolean) {
                    renderedProps.push(createElement(Checkbox, {
                        props: {
                            label: prop,
                            checked: settings[prop],
                        },
                        style: {
                            marginBottom: '0.5rem',
                        },
                        on: {
                            change: (event) => {
                                settings[prop] = event;
                                this.$forceUpdate();
                            },
                        },
                    }));
                }
            }

            const currentProps = {};
            for (const prop in props) {
                currentProps[prop] = settings[prop];
            }

            return { rendered: renderedProps, current: currentProps };
        },
    },
    render(createElement) {
        const props = this.renderSettings(this.settings, this.element.props, createElement);

        const mixinsRenderedProps = [];
        let mixinsCurrentProps = {};
        if (this.element.hasOwnProperty('mixins')) {
            this.element.mixins.forEach((mixinElement) => {
                const mixinProps = this.renderSettings(this.mixinsSettings, mixinElement.props, createElement);
                mixinsRenderedProps.push(mixinProps.rendered);
                mixinsCurrentProps = Object.assign(mixinsCurrentProps, mixinProps.current);
            },
            );
        }

        let mixinsPropsDiv;
        if (mixinsRenderedProps.length > 0) {
            mixinsPropsDiv = createElement('details', {
                style: {
                    marginBottom: '1rem',
                },
            }, [
                createElement('summary', {
                    class: 'sg-pattern-name',
                }, 'From Mixins'),
                createElement('div', {
                    style: {
                        border: '1px solid #c4c4c4',
                        padding: '1rem',
                        margin: '1rem 2rem 0',
                    },
                }, mixinsRenderedProps),
            ]);
        }

        return createElement('div', { class: 'sg-pattern' }, [
            createElement('details', {
                class: 'sg-pattern-details',
            }, [
                createElement('summary', {
                    class: 'sg-pattern-name',
                }, this.name),
                createElement('div', {
                    style: {
                        border: '1px solid #c4c4c4',
                        padding: '1rem',
                        margin: '1rem 2rem 0',
                    },
                }, [mixinsPropsDiv, props.rendered]),
            ]),
            createElement('div', {
                class: 'sg-pattern-preview',
            }, [
                createElement(this.element, {
                    props: Object.assign(props.current, mixinsCurrentProps),
                }),
            ]),
        ]);
    },
};
</script>
